module.exports = __webpack_public_path__ + "assets/img/ticket_icon_back.d277ab00.png";